class Customer.ConversationAttributesListView extends Backbone.View

  initialize: (@options = {}) ->
    @attributes = @options.collection
    @listenTo(@attributes, 'reset', @_addAttributes)
    @listenTo(@attributes, 'conversation:attributes:update', @_afterUpdate)
    super @options

  _onCancel: =>
    @_keepCustomerSessionAlive()
    @$el.find('.conversation-attributes-list').empty()
    @attributes.rollBackModels()
    @show()

  canUpdate: =>
    @attributes.canUpdate()

  _onUpdate: =>
    @_keepCustomerSessionAlive()
    unless @checkAllValid()
      showError(I18n.t('customer.dashboard.conversations.attributes.error'))
      @_onCancel()
      return
    @$el.find('.customer-button').addClass('disabled')
    added = []
    deleted = []
    for view in @attributeViews
      added.push view.getAdded()
      deleted.push view.getDeleted()
    @attributes.saveChanges
      added: _.compact(added)
      deleted: _.compact(deleted)

  show: ->
    if !@attributes.isAlreadyLoaded()
      @_loading()
    else
      @_addAttributes()

  _afterUpdate: =>
    @trigger('conversation:attributes:update')

  _addAttributes: =>
    @_loading(false)
    if @attributes.isEmpty()
      @$el.find('.no-configured-attributes').removeClass('hidden')
    else
      try
        visibleAttributes = @attributes.filter (attribute) -> !attribute.get('hidden')

        @attributeViews = _.compact(visibleAttributes.map(@_getViewFor))
        _.each(@attributeViews, (attributeView) =>
          attributeViewEl = $(attributeView.render().el)
          attributeViewEl.addClass('hidden') if attributeView.model.get('definition').get('code').startsWith('_')
          @$el.find('.conversation-attributes-list').append(attributeViewEl)
          @listenTo(attributeView, 'custom_attributes:invalid_attribute', @disableSaveButton)
          @listenTo(attributeView, 'custom_attributes:valid_attribute', @checkAllValid)
          @listenTo(attributeView, 'conversation:attributes:edit', () => @trigger('conversation:attributes:edit'))
          attributeView.afterRender()
        )
        @delegateEvents()
      catch error
        console.error(error)
        window.showError(I18n.t('customer.dashboard.conversations.attributes.error'));

  disableSaveButton: ->
    @trigger('custom_attributes:disable_save')

  checkAllValid: ->
    allValid = _.every(@attributeViews, (attributeView) -> attributeView.validValue())
    @trigger('custom_attributes:enable_save') if allValid
    allValid

  _loading: (show=true) ->
    element = @$el.find('.nano-content')
    if show
      element.addClass('processing')
      @$el.find('.loading-spinner').show()
    else
      element.removeClass('processing')
      @$el.find('.loading-spinner').hide()

  _getViewFor: (attribute) ->
    attributeName = attribute.get('definition').get('attribute_type_name')
    className = Customer["#{attributeName}AttributeView"]
    if className
      new className(model: attribute)
    else
      jsLogger.fatal("There is no View #{attributeName}AttributeView for: #{JSON.stringify(attribute)}")
      console.log('There is no View for: ' + JSON.stringify(attribute))

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  onAttributesValidationError: (ticketAttributeErrors) =>
    @attributeViews.filter(
      (attributeView) -> ticketAttributeErrors.hasOwnProperty(attributeView.getDefinitionCode())
    ).forEach((attributeView) -> attributeView.$el.addClass('validation-error'))

  onTicketClose: =>
    return if !@attributeViews
    @attributeViews.forEach((attributeView) -> attributeView.$el.removeClass('validation-error'))
